import * as React from 'react';
import { Icon, Typography, tk, Button } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { useGetStepsTabs } from '@/scopes/checkout/domain/hooks';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';

export function PreviousStep() {
  const { isLoading, items } = useGetStepsTabs();

  const router = useRouter();
  const searchParams = useSearchParams();

  if (isLoading) return '';

  const previousStep = items.findLast((step) => step.completed);

  if (!previousStep || (previousStep && !previousStep.url)) return null;

  const goToPreviousStep = () => {
    router.push(`${previousStep.url}?sid=${searchParams.get('sid')}`);
  };

  return (
    <PreviousStepButton
      $hierarchy="tertiary"
      $withoutColor
      $size="default"
      onClick={goToPreviousStep}
      disabled={isLoading}
    >
      <Icon glyph="IconChevronLeft" size="sm" />
      <Typography $variant="label">{previousStep.text}</Typography>
    </PreviousStepButton>
  );
}

const PreviousStepButton = styled(Button)`
  color: ${tk('color_semantic_text_strong')};
  width: fit-content;
  padding: 0;
`;
